module.exports = __webpack_public_path__ + "img/login_left22.9d8a4bec.png";